import QuestionDTO from "@/app/exercise/components/question/core/DTO/questionDTO";
import { moveArrayElem } from '@/util';

export default class ChapterModel {
  constructor(item = {}) {
    this.id = item.id;
    this.name = item.name;
    this.order = item.order;
    this.description = item.description;
    this.thumbnail = item.thumbnail;
    this.category = item.category;
    this.publicVisible = item.public_visible;
    this.videos = item.videos ? item.videos.map(question => new QuestionDTO(question)) : [];
    this.questions = item.questions ? item.questions.map(question => new QuestionDTO(question)) : [];
    this.theory = item.theory ? item.theory.map(question => new QuestionDTO(question)) : [];
    this.is_motor = item.is_motor || false;
    this.is_auto = item.is_auto || false;
    this.is_scooter = item.is_scooter || false;
    this.is_wiki = item.is_wiki || false;
    this.is_les = item.is_les || false;
    this.is_online = item.is_online || false;

    this._apiAttributes = {
      name: 'name',
      order: 'order'
    }
  }

  get licenseTypes() {
    const licenseTypes = [];
    if (this.is_motor) licenseTypes.push('motor');
    if (this.is_auto) licenseTypes.push('auto');
    if (this.is_scooter) licenseTypes.push('scooter');
    return licenseTypes.join(', ');
  }

  addItem(item, questionType, index = null) {
    const isDuplicate = this[questionType].find(question => question.id === item.id);
    if (!isDuplicate) {
      if( index !== null ) {
        this[questionType].splice(index, 0, item);
      } else {
        this[questionType].push(item);
      }
      return;
    }
    return Boolean(isDuplicate);
  }

  removeItem(item, questionType) {
    if (Array.isArray(item)) {
      this[questionType] = this[questionType].filter(question => {
        const isDeletedItemInQuestions = item.find(_item => question.id === _item.id);
        if (isDeletedItemInQuestions) return false;
        return true;
      })
    } else {
      this[questionType] = this[questionType].filter(question => question.id !== item.id)
    }
  }

  moveItem(direction, index, questionType) {
    if (!(index === 0 && direction === 'up')) {
      const moveItemToIndex = direction === 'up' ? index - 1 : index + 1;
      moveArrayElem(this[questionType], index, moveItemToIndex);
    }
  }

  isValid() {
    let valid = true,
      requiredFields = [
        this.name,
      ]
    requiredFields.forEach(field => {
      if(!field) valid = false
    })
    return valid
  }

  validate (validator) {
    validator.resetFields()
    this.validateLicenseTypes(validator)
    return validator.isValid()
  }

  validateLicenseTypes(validator) {
    if (!this.is_motor && !this.is_auto && !this.is_scooter) {
      validator.invalidField('licenseTypes', 'At least one license type should be selected');
    }
  }

  getApiData() {
    return {
      name: this.name,
      description: this.description,
      questions: this.questions.map(question => question.id),
      videos: this.videos.map(question => question.id),
      theory: this.theory.map(question => question.id),
      order: this.order,
      public_visible: this.publicVisible,
      thumbnail: this.thumbnail,
      category: this.category,
      is_motor: this.is_motor || false,
      is_auto: this.is_auto || false,
      is_scooter: this.is_scooter || false,
      is_wiki: this.is_wiki || false,
      is_les: this.is_les || false,
      is_online: this.is_online || false,
    }
  }
}
